import { HttpHeaders, HttpParams } from '@angular/common/http';
import { CustomURLEncoder } from '@models/custom-url-encoder';
import { LoadCartRequest } from '@models/load-cart-request';
import { Test } from '@models/test';

export class AnalyteCareLoadCartRequest extends LoadCartRequest {
  public tests?: Test[];
  public coupon: string;
  public center_id?: number;
  public state_short_name?: string;
  public authToken?: string;

  /**
   * Gets the Authorization header so the API can resolve the business account pricing for the cart.
   *
   * @returns { HttpHeaders | null } the headers for the load cart request, or null when there is no token.
   **/
  public override getHttpHeaders(): HttpHeaders | null {
    return this.authToken ? new HttpHeaders({ Authorization: `Bearer ${this.authToken}` }) : null;
  }

  /**
   * Build query params object for load cart url for STDcheck.
   *
   * @returns { HttpParams } the query params object for load cart url.
   **/
  public override getHttpParams(): HttpParams {
    let params = new HttpParams({ encoder: new CustomURLEncoder() });

    if (this.center_id) {
      params = params.append('center_id', this.center_id);
    }

    if (this.coupon) {
      params = params.append('coupon', this.coupon);
    }

    if (this.tests) {
      this.tests.forEach(
        (test) => (params = params.append(test.slug ? 'slug[]' : 'tests[][name]', test.slug || test.name)),
      );
    }

    if (this.state_short_name) {
      params = params.append('state_short_name', this.state_short_name);
    }

    return params;
  }
}
